import { t } from "./ui/strings";

const params = new URLSearchParams(location.search);
const invited = params.has("sto");
const game = params.get("igra") ?? (invited ? "enka" : null);

if (game === "remi") {
  document.title = "Remi 51 · Za stolom";
  void import("./remi/main");
} else if (game === "enka") {
  document.title = "Jedna! · Za stolom";
  void import("./enka");
} else {
  showGamePicker();
}

function showGamePicker(): void {
  document.title = "Za stolom";
  const root = document.getElementById("hud") as HTMLElement;
  const panel = document.createElement("main");
  panel.className = "game-picker";
  const heading = document.createElement("div");
  heading.className = "game-picker-heading";
  const title = document.createElement("h1");
  title.textContent = "ZA STOLOM";
  const tag = document.createElement("p");
  tag.textContent = t.chooseGame;
  heading.append(title, tag);

  const cards = document.createElement("div");
  cards.className = "game-choices";
  cards.append(
    choice("enka", "JEDNA!", "Brza igra boja, poteza i dobrog tajminga.", "🟨"),
    choice("remi", "REMI 51", "Složi grupe i nizove, otvori se na 51.", "♥"),
  );
  panel.append(heading, cards, paragraph("Jedan sto · iste kamere · dve potpuno odvojene igre"));
  root.replaceChildren(panel);
}

function choice(id: string, name: string, description: string, symbol: string): HTMLButtonElement {
  const button = document.createElement("button");
  button.className = `game-choice ${id}`;
  button.type = "button";
  const icon = document.createElement("span");
  icon.className = "game-choice-icon";
  icon.textContent = symbol;
  const label = document.createElement("strong");
  label.textContent = name;
  const text = document.createElement("span");
  text.textContent = description;
  button.append(icon, label, text);
  button.addEventListener("click", () => location.assign(`/?igra=${id}`));
  return button;
}

function paragraph(text: string): HTMLParagraphElement {
  const p = document.createElement("p");
  p.className = "small";
  p.textContent = text;
  return p;
}
